/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  MoveIssuerRequestBody,
  MoveIssuerRequestBody$Outbound,
  MoveIssuerRequestBody$outboundSchema,
} from "../components/moveissuerrequestbody.js";

export type MoveOrganizationRemoteSessionIssuerSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type MoveOrganizationRemoteSessionIssuerRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  moveIssuerRequestBody: MoveIssuerRequestBody;
};

/** @internal */
export type MoveOrganizationRemoteSessionIssuerSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const MoveOrganizationRemoteSessionIssuerSecurity$outboundSchema:
  z.ZodMiniType<
    MoveOrganizationRemoteSessionIssuerSecurity$Outbound,
    MoveOrganizationRemoteSessionIssuerSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
      apikeyHeaderGramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
      });
    }),
  );

export function moveOrganizationRemoteSessionIssuerSecurityToJSON(
  moveOrganizationRemoteSessionIssuerSecurity:
    MoveOrganizationRemoteSessionIssuerSecurity,
): string {
  return JSON.stringify(
    MoveOrganizationRemoteSessionIssuerSecurity$outboundSchema.parse(
      moveOrganizationRemoteSessionIssuerSecurity,
    ),
  );
}

/** @internal */
export type MoveOrganizationRemoteSessionIssuerRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  MoveIssuerRequestBody: MoveIssuerRequestBody$Outbound;
};

/** @internal */
export const MoveOrganizationRemoteSessionIssuerRequest$outboundSchema:
  z.ZodMiniType<
    MoveOrganizationRemoteSessionIssuerRequest$Outbound,
    MoveOrganizationRemoteSessionIssuerRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
      moveIssuerRequestBody: MoveIssuerRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
        moveIssuerRequestBody: "MoveIssuerRequestBody",
      });
    }),
  );

export function moveOrganizationRemoteSessionIssuerRequestToJSON(
  moveOrganizationRemoteSessionIssuerRequest:
    MoveOrganizationRemoteSessionIssuerRequest,
): string {
  return JSON.stringify(
    MoveOrganizationRemoteSessionIssuerRequest$outboundSchema.parse(
      moveOrganizationRemoteSessionIssuerRequest,
    ),
  );
}
